import axios, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/monitor`;

export const systemInfo = async () => {
  const url = `${baseURL}/system-info`;
  return handler(() => axios.get(url));
}

export const database = async () => {
  const url = `${baseURL}/database`;
  return handler(() => axios.get(url));
}

export const databaseSensor = async () => {
  const url = `${baseURL}/database/sensors`;
  console.log('databaseSensor', url);
  return handler(() => axios.get(url));
}

export const databaseUser = async () => {
  const url = `${baseURL}/database/users`;
  return handler(() => axios.get(url));
}

export const databaseGroup = async () => {
  const url = `${baseURL}/database/groups`;
  return handler(() => axios.get(url));
}

export const databaseLog = async () => {
  const url = `${baseURL}/database/logs`;
  return handler(() => axios.get(url));
}


const monitorService = {
  systemInfo,
  database,
  databaseSensor,
  databaseUser,
  databaseGroup,
  databaseLog,
}

export default monitorService;
